import React, {Fragment} from "react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import classes from 'classnames';
import 'sweetalert2/src/sweetalert2.scss'

const MySwal = withReactContent(Swal);

class SweetAlertBase {

    width = {
        sm: "25%",
        md: "50%",
        lg: "75%",
    };

    config = {};

    html = null;

    defaultConfig = {
        width: this.width[this.type()],
        buttonsStyling: false,
        showCancelButton: false,
        customClass: {
            container: `${this.className()}-modal`,
            popup: `${this.className()}-popup`,
            actions: `${this.className()}-actions`,
            confirmButton: classes(`${this.className()}-confirm-button`, this.confirmButtonClasses()),
            cancelButton: classes(`${this.className()}-cancel-button`, this.cancelButtonClasses()),
        }
    };

    type() {
        return 'md'
    }

    className() {
        return "sweet-alert";
    }

    confirmButtonClasses() {
        return '';
    }

    cancelButtonClasses() {
        return '';
    }

    setHtml(data) {
        return this.html;
    }

    fire(options, data) {
        return MySwal.fire({
            ...this.defaultConfig,
            ...this.config,
            html: this.setHtml(data),
            ...options,
        })
    }
}

export default SweetAlertBase;